import { render, staticRenderFns } from "./DCL.vue?vue&type=template&id=f32f316e&scoped=true&"
import script from "./DCL.vue?vue&type=script&lang=js&"
export * from "./DCL.vue?vue&type=script&lang=js&"
import style0 from "./DCL.vue?vue&type=style&index=0&id=f32f316e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32f316e",
  null
  
)

export default component.exports